module.exports = __webpack_public_path__ + "media/images/tyre-40e0aa27f267545c2c1cf7e292c86ec1.jpg";